export default "__VITE_ASSET__TZLCTL14__"